import app from 'app/app'
import { get } from 'tools/request'

export let UserSnap = { open: () => alert('UserSnap is not available') }
let isLoaded
const integrationName = 'usersnap'
let apiKey
export const usersnapStart = (config = {}) => {
	get('/portal/Settings').then(config =>
		apiKey = config.Settings.USER_SNAP_API_KEY)
}
export const usersnapOpen = (onOpen?) => {
	if (!isLoaded) {
		// load and then open
		isLoaded = true
		get('/portal/Settings').then(config => {
			apiKey = config.Settings.USER_SNAP_API_KEY
			usersnapLoad(() => {
				UserSnap.logEvent('open_us')
				//UserSnap.open()
			}, onOpen)
		})
	} else {
		UserSnap.logEvent('open_us')
		//UserSnap.open()
	}
}
const usersnapLoad = (callback, onOpen?) => {
	let s, x
	if (apiKey && window.location.hostname !== 'localhost') {
		window.onUsersnapLoad = function(api) { // this callback currently does not seem to be called, despite the documentation saying this is how it should be done
			UserSnap = api
			api.init({
				button: null,
				shortcut: {
					key: 'u',
					ctrlKey: true,
					altKey: false,
				},
			})
			api.on('open', function(event) {
				event.api.setValue('email', app.user.Email)
				onOpen?.(event.api)
			})
			callback()
		}
		s = document.createElement('script')
		s.type = 'text/javascript'
		s.async = true
		s.src = '//widget.usersnap.com/global/load/' + apiKey + '?onload=onUsersnapLoad'
		s.onload = function() { // since onUsersnapLoad doesn't seem to get called, manually wait for things to load
			setTimeout(function() {
				try {
					UserSnap.setEmailBox(app.user.Email)
				} catch (error) {}
			}, 1000)
		}
		x = document.getElementsByTagName('head')[0]
		return x.appendChild(s)
	} else {
		callback()
	}
}
